module.exports = __webpack_public_path__ + "img/city.e5f3e506.png";